<template>
  <Lists @update="() => $emit('update')" />
</template>

<script>
import Lists from '../../components/list/index.vue'
export default {
  components: {
    Lists,
  },
}
</script>

<style scoped lang="scss"></style>
